// LARI-GTIN-INTERNO (I.178): espelho da régua do banco (public.is_valid_gtin). GTIN de fábrica tem 8, 12, 13 ou 14
// dígitos e o último confere pelo dígito verificador. Código que não passa vai no campo "Código de barras interno".

export const GTIN_INVALID_MESSAGE =
  'GTIN inválido: confira o dígito verificador ou use o campo Código de barras interno';

export function isValidGtin(code: string | null | undefined): boolean {
  if (!code || !/^(\d{8}|\d{12}|\d{13}|\d{14})$/.test(code)) return false;
  const full = code.padStart(14, '0');
  let sum = 0;
  for (let i = 0; i < 13; i++) {
    sum += Number(full[i]) * (i % 2 === 0 ? 3 : 1);
  }
  return (10 - (sum % 10)) % 10 === Number(full[13]);
}

/** Vazio (ou só espaços) vale como "sem código": vai ao banco como nulo, nunca como texto vazio. */
export function barcodeOrNull(value: string | null | undefined): string | null {
  const v = (value ?? '').trim();
  return v === '' ? null : v;
}

/** O que mostrar na coluna de código de barras: o GTIN; sem GTIN, o interno marcado como interno. */
export function barcodeDisplay(ean: string | null | undefined, internalBarcode: string | null | undefined): string | null {
  const gtin = barcodeOrNull(ean);
  if (gtin) return gtin;
  const internal = barcodeOrNull(internalBarcode);
  return internal ? `${internal} (interno)` : null;
}

/** Recusa da trava do banco (products_ean_gtin_check) vinda de qualquer tela antiga ou nova. */
export function isGtinCheckError(error: unknown): boolean {
  const e = error as { code?: string; message?: string } | null;
  return !!e && e.code === '23514' && (e.message ?? '').includes('products_ean_gtin_check');
}
